export enum ChromeMessageExternalFunction {
    UUID = 'uuid',
    LIST_PRINTERS = 'list-printers',
    GET_PRINTER_INFO = 'get-printer-info',
}

export interface ChromeMessageExternal {
    type: ChromeMessageExternalFunction;
    [x: string]: unknown;
}
